import {
    selectTotalPriceExcludingTax,
    selectTotalPriceIncludingTax,
} from '@repo/api-adapters/selectors/price.selectors';
import { DtoProvidedServiceServicePaymentToEnum } from '@repo/api-types/order-retrieval';

import { useAssetServices } from '@/hooks/asset-services.hooks';
import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { getServicePrice } from '@/utils/services.utils';
import { getAppConfig } from '@/utils/window.utils';

export const useAssetPriceTotals = () => {
    const { assetType, assetId } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const config = getAppConfig();

    const totalPrice = config.feature.priceExclTax?.enable
        ? selectTotalPriceExcludingTax(data)
        : selectTotalPriceIncludingTax(data);

    const assetServices = useAssetServices(data);
    const priceValueField = config.feature.priceExclTax?.enable ? 'priceExclTax' : 'priceInclTax';

    let toServiceProviders = 0;

    for (const service of assetServices) {
        const servicePrice = getServicePrice(service, priceValueField);
        toServiceProviders += service.servicePaymentTo === DtoProvidedServiceServicePaymentToEnum.SP ? servicePrice : 0;
    }

    return {
        toIkea: totalPrice?.totalValue ?? 0,
        toServiceProviders,
        totalItemsValue: totalPrice?.itemsValue ?? 0,
        totalOrderValue: (totalPrice?.totalValue ?? 0) + toServiceProviders,
        vatValue: totalPrice?.vat ?? 0,
    };
};
